// Buttons ported from botriq-admin-fe's Robot Portal UI kit. Plain <button>s so
// they work identically inside forms, tables, and cards without MUI theme coupling.
import PropTypes from "prop-types";
import { Icon } from "./Icon";

const TONES = {
  primary: { background: "var(--bq-accent)", color: "#fff", border: "1px solid var(--bq-accent)" },
  ghost: {
    background: "var(--bq-surface2)",
    color: "var(--bq-text)",
    border: "1px solid var(--bq-border)",
  },
  danger: {
    background: "var(--bq-dangerSoft)",
    color: "var(--bq-danger)",
    border: "1px solid transparent",
  },
  subtle: { background: "transparent", color: "var(--bq-text2)", border: "1px solid transparent" },
};

export const Btn = ({
  label,
  icon,
  tone = "ghost",
  size = "md",
  full,
  onClick,
  type = "button",
  disabled,
  style,
}) => {
  const pad = size === "sm" ? "6px 10px" : "8px 13px";
  const fs = size === "sm" ? 12 : 13;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="rp-btn"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 7,
        padding: pad,
        fontSize: fs,
        fontWeight: 600,
        borderRadius: 8,
        transition: "filter .13s ease, border-color .13s ease",
        width: full ? "100%" : "auto",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.55 : 1,
        ...TONES[tone],
        ...style,
      }}
    >
      {icon && <Icon name={icon} size={size === "sm" ? 14 : 15} />}
      {label}
    </button>
  );
};

Btn.propTypes = {
  label: PropTypes.node,
  icon: PropTypes.string,
  tone: PropTypes.oneOf(["primary", "ghost", "danger", "subtle"]),
  size: PropTypes.oneOf(["sm", "md"]),
  full: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export const IconBtn = ({ icon, onClick, active, title, size = 16, disabled, style }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    aria-label={title}
    disabled={disabled}
    className="rp-iconbtn"
    style={{
      width: 32,
      height: 32,
      display: "grid",
      placeItems: "center",
      borderRadius: 8,
      border: `1px solid ${active ? "var(--bq-accent)" : "var(--bq-border)"}`,
      background: active ? "var(--bq-accentSoft)" : "var(--bq-surface2)",
      color: active ? "var(--bq-accent)" : "var(--bq-text2)",
      transition: "color .13s ease, border-color .13s ease",
      cursor: disabled ? "default" : "pointer",
      opacity: disabled ? 0.5 : 1,
      ...style,
    }}
  >
    <Icon name={icon} size={size} />
  </button>
);

IconBtn.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  title: PropTypes.string,
  size: PropTypes.number,
  disabled: PropTypes.bool,
  style: PropTypes.object,
};

export default Btn;
